import { Builder } from "@builder.io/react";

import themeTimeLine from "./themeTimeLine";

Builder.registerComponent(themeTimeLine, {
  name: "Theme TimeLine Section",
  inputs: [
    {
      type: "list",
      name: "timeline",
      friendlyName: "TimeLine",
      defaultValue: [
        {
          year: "2009",
          summary: "Experts from MIT and Tufts form InsideTracker as a research initiative.",
        }
      ],
      subFields: [
        {
            name: "year",
            type: "string",
            required: true,
            friendlyName: "Year"
        },
        {
            name: "summary",
            type: "string",
            required: true,
            friendlyName: "Summary"
        },
        {
          name: "isTop",
          type: "boolean",
          friendlyName: "Placed at the top?",
          defaultValue: true
        }
      ]
    }
  ],
});
